module.exports = __webpack_public_path__ + "static/media/youtube.9824f8fc.png";